import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  personalBrandingIcon,
  seoMarketingIcon,
  socialMarketingIcon,
  payPerClickIcon,
  emailMarketinIcon,
  analyticIcon,
} from "../../../../assets/icons/serviceIcon/index";

const items = [
  {
    name: "Influencer Outreach & Collaboration",
    text: "We find the right influencers, provide them with custom scripts and edit videos to keep your brand message on point.",
  },
  {
    name: "Affiliate Program Setup",
    text: "We create a custom affiliate system with trackable links, commission structures and easy onboarding for promoters.",
  },
  {
    name: "Campaign Monitoring & Reporting",
    text: "We track every story, post and link shared and send you reports on reach, engagement, traffic, and ROI.",
  },
];

const otherService = [
  {
    icon: seoMarketingIcon,
    name: "Seo & Content Marketing",
    des: "Get ranked on Google and stay in hearts with content that truly speaks to your people.",
    path: "/seo-content-marketing",
  },
  {
    icon: socialMarketingIcon,
    name: "Social Media Marketing (SMM)",
    des: "Show up where your audience scrolls, shares and starts to trust you.",
    path: "/social-media-marketing",
  },
  {
    icon: payPerClickIcon,
    name: "Pay Per Click",
    des: "Get your brand seen by the right people, right when they’re searching for you.",
    path: "/pay-per-click",
  },
  {
    icon: emailMarketinIcon,
    name: "Email & CRM Marketing",
    des: "Stay in touch in a meaningful way with emails people actually want to open.",
    path: "/email-marketing",
  },
  {
    icon: personalBrandingIcon,
    name: "personal Branding",
    des: "Turn your story, skills, and personality into something people remember and trust.",
    path: "/personal-branding",
  },
  {
    icon: analyticIcon,
    name: "Analytics  & Performance Tracking ",
    des: "Know what’s working, what’s not, and what to do next without the guesswork.",
    path: "/analytic-and-performance-tracking",
  },
];

const InfluencerMarketing = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Marketing"
        description="We help you team up with the right voices who already have your audience’s attention, so your brand feels more like a recommendation than a promotion."
        heading="Influencer & Affiliate"
      />
      <NewCommonServiceForm
        title="Influencer & Affiliate Marketing"
        items={items}
      />
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default InfluencerMarketing;
